<script setup>
  import BaseModal from '@/components/base/BaseModal.vue';

  const showModal = defineModel();

  const props = defineProps({
    downloadInfo: {
      type: Object,
      required: true
    }
  });

  function saveFile(url, filename) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "file-name";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }  

  function handleDownloadData() {
    saveFile(props.downloadInfo.url, props.downloadInfo.filename);
    showModal.value = false;
  }  
</script>

<template>

  <BaseModal
    v-model="showModal"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">Archive Data Download</h2>
    </header>          
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <div class="jwx-page-block jwx-meta-data__list-block-body">
          <ul class="jwx-meta-data__list">
            <li class="jwx-meta-data__list-item">
              <span class="jwx-meta-data__list-item-title">Start Date:</span>
              <div class="jwx-meta-data_list-item-body">
                <span class="jwx-meta-data__list-item-value">{{ props.downloadInfo.startDate }}</span>
              </div>
            </li>
            <li class="jwx-meta-data__list-item">
              <span class="jwx-meta-data__list-item-title">End Date:</span>
              <div class="jwx-meta-data_list-item-body">
                <span class="jwx-meta-data__list-item-value">{{ props.downloadInfo.endDate }}</span>
              </div>
            </li>
            <li class="jwx-meta-data__list-item">
              <span class="jwx-meta-data__list-item-title">File Type:</span>
              <div class="jwx-meta-data_list-item-body">
                <span class="jwx-meta-data__list-item-value">{{ props.downloadInfo.type.toUpperCase() }}</span>
              </div>
            </li>
            <li class="jwx-meta-data__list-item" data-direction="column">
              <span class="jwx-meta-data__list-item-title">Fields:</span>
              <div class="jwx-meta-data__list-item-body" data-full-width>
                <span class="jwx-meta-data__list-item-value">
                  All available fields. Can include the following: station meta data. wind(avg.gust.lull.dir), air temperature, pressure. precipitation, water temperature, wave height, wave period.
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button 
          type="button" 
          @click.prevent="showModal = false;"
          class="jwx-button"
        >
          Cancel
        </button>
        <button 
          type="button" 
          @click.prevent="handleDownloadData"
          class="jwx-button jwx-button--success"
        >
          Download
        </button>
      </div>
    </div>                  
  </BaseModal>  
</template>